import generateBarcode from 'jsbarcode';
import React, { FC, useEffect } from 'react';
import './barcode.scss';

type Props = {
    upc: string | number
}

export const Barcode: FC<Props> = ({upc}) => {

    const id = `barcode-${upc.toString().replace(/\D/g, '').trim()}`

    useEffect(() => {
        generateBarcode(`#${id}`, upc.toString(), {
            format: 'code128'
        })
    }, [])

    return (
        <canvas id={id}></canvas>
    )
}